import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { tap } from 'rxjs';
import { ActiveUserService } from '../services/common/active-user.service';
import { ClinicalNoteService } from '../services/common/clinical-note.service';
import { ScopesEnum } from '../types/enum/viewMode';
import { Scopes } from '../types/util';

@Directive({
  selector: '[jargonViewMode]'
})
export class ViewModeDirective implements OnInit {

  private scope!: Scopes;
  private activeScopes: Scopes[];
  private rendered: boolean = false;

  constructor(
    private clinicalNoteService: ClinicalNoteService,
    private activeUserService: ActiveUserService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    this.activeScopes = this.activeUserService.scopes;
  }

  @Input('jargonViewMode') set allowedMode(scope: Scopes) {
    this.scope = scope;
  }

  ngOnInit() {
    this.resolveRendering();
    this.clinicalNoteService.config.pipe(
      tap(() => this.resolveRendering())
    ).subscribe();
  }

  resolveRendering() {
    if (this.activeScopes.includes(this.scope)) {
      if (
        ([
          ScopesEnum.SCOPE_NOTES_WRITE,
          ScopesEnum.SCOPE_NOTES_FINALIZE,
          ScopesEnum.SCOPE_REVIEW_WRITE,
          ScopesEnum.SCOPE_BUILDERS_WRITE
        ] as Scopes[]).includes(this.scope)
        && this.clinicalNoteService.isReadOnly
      ) {
        this.viewContainer.clear();
        this.rendered = false;
      } else {
        if (!this.rendered) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.rendered = true;
        }
      }
    } else {
      this.viewContainer.clear();
      this.rendered = false;
    }
  }
}
